import { HTTPResponse } from 'types/responses'
import type { StripeElementsOptionsMode } from '@stripe/stripe-js'
import { CustomerType } from 'types/customer'

export interface StripePaymentMethod {
  isAppActive?: () => boolean
  isEnabled?: () => boolean
  hasCapabilities?: () => boolean
  loadDependencies?: () => Promise<void | any[]>
}

export interface StripePaymentMethodWithTermsReadOnly {
  isTermsAccepted: () => boolean
}

export interface StripePaymentMethodWithTerms extends StripePaymentMethodWithTermsReadOnly {
  acceptTerms: () => Promise<HTTPResponse>
}

export interface StripePaymentMethodConstantDependencies {
  isAvailableForPayerType?: (type: CustomerType) => boolean
  isAvailableForCountryCurrency: (countryCode: string, currency: string) => boolean
}

export interface StripePaymentElement {
  getStripeElementPayload(args: {
    isDealsPage?: boolean
    isManagePage?: boolean
    mode?: string
  }): StripeElementsOptionsMode
}

export interface StripePaymentMethodShop extends StripePaymentElement {
  isAvailable(activeCountry: string, currency: string): boolean
  isAvailableForPayerType(): boolean
  isAvailableForPricingPlan(params: {
    withTestPeriod: boolean
    withCustomStart: boolean
    pricingPlanForm: string
  }): boolean
}

export interface StripeElementOptions {
  getPaymentElementOptions: () => any
}

export interface StripeElementsPayloads {
  getTwintStripeElementPayload: (mode?: string) => StripeElementsOptionsMode
  getMonduStripeElementPayload: (mode?: string) => StripeElementsOptionsMode
  getPayByBankStripeElementPayload: (mode?: string) => StripeElementsOptionsMode
  getStripeCardElementPayload: (mode?: string) => StripeElementsOptionsMode
  getIdealStripeElementPayload: (mode?: string) => StripeElementsOptionsMode
  getSepaStripeElementPayload: (mode?: string) => StripeElementsOptionsMode
  getP24StripeElementPayload: (mode?: string) => StripeElementsOptionsMode
  getStripeElementPayload: (method: string, mode?: string) => StripeElementsOptionsMode
}

export const PAYMENT_ELEMENTS_MODE = {
  setup: 'setup' as const,
  payment: 'payment' as const,
}
